import styled, { createGlobalStyle } from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const GlobalStyles = createGlobalStyle`
  html {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-family: Poppins;

    ${breakpoint('tablet')`
      font-size: 16px;
    `}

    ${breakpoint('desktop')`
      font-size: 18px;
    `}
  }

  body {
    margin: 0;
    padding: 0;
  }
`

export const Main = styled.main``
